import { Container } from "../../components/Container";
import { Body, Content } from "../../components/Body";
import { Title } from "../../components/Title";
import content from "./Text.json";
import { useTitleChange } from "hooks/useTitleChange";
export const FrequentQuestions = () => {
  useTitleChange("Preguntas Frecuentes");
  return (
    <Container>
      <Title>Preguntas Frecuentes</Title>
      <Body content={content as Content[]} />
    </Container>
  );
};
